import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { CountryModel } from "../../models/country-model";
 
const AddingNewState = () => {
  const [countries, setCountries] = useState<CountryModel[]>([]);
  const [selectedCountryId, setSelectedCountryId] = useState<string | null>(null);
  const [newStateName, setNewStateName] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const toast = useRef<Toast>(null);
 
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countries = await UserAddressService.getAllCountryNames();
        setCountries(countries);
      } catch (error) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load countries",
        });
      }
    };
    loadCountries();
  }, []);
 
  const handleAddState = async () => {
    if (!selectedCountryId || !newStateName.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing Fields",
        detail: "Please select a country and enter a state name",
      });
      return;
    }
    setIsSubmitting(true);
 
    try {
      const response = await UserAddressService.addNewState({
        stateName: newStateName,
        countryId: selectedCountryId,
      });
      if (response?.id) {
        toast.current?.show({
          severity: "success",
          summary: "State Added",
          detail: `${newStateName} was added successfully!`,
          life: 2000,      
        });
        setNewStateName("");
        setSelectedCountryId(null);
        setTimeout(() => {
          window.location.reload();
        },500);
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "Unable to add state or it already exists.",
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while adding the state.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
 
  return (
    <>
      <Toast ref={toast} position="top-right" />
 
      <div className="col-12">
        <h5 className="border-round order-top-color p-2">Add New State</h5>
      </div>
 
      <div className="flex flex-column md:flex-row">
        <div className="col-12 mt-2">
          <div className="p-fluid formgrid grid">
            <div className="field col-12 md:col-6">
              <label htmlFor="country" className="label-semi-bold">Select Country<span className="required">*</span></label>
              <Dropdown
                id="country"
                value={selectedCountryId}
                onChange={(e) => setSelectedCountryId(e.value)}
                options={countries}
                optionLabel="countryName"
                optionValue="countryId"
                placeholder="Select country"
                filter
                filterBy="countryName"
                showClear
                resetFilterOnHide={true}
                disabled={isSubmitting}
              />
            </div>
 
            <div className="field col-12 md:col-6">
              <label htmlFor="stateName" className="label-semi-bold">State Name<span className="required">*</span></label>
              <InputText
                id="stateName"
                value={newStateName}
                onChange={(e) => setNewStateName(e.target.value)}
                onKeyDown={(e) => {
                  if (!/^[a-zA-Z ]$/.test(e.key) && e.key !== 'Backspace') {
                      e.preventDefault();
                  }
              }}
                placeholder="Enter state name"
                disabled={isSubmitting}
              />
            </div>
          </div>
 
          <div className="col-12 flex justify-content-end mt-3">
            <Button
              label="Save"
              icon="pi pi-check"
              className="p-button-success"
              onClick={handleAddState}
              loading={isSubmitting}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
    </>
  );
};
 
export default AddingNewState;
 
 
 